/**
 * Route for `detail-drawer-over-row`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { DetailDrawerOverRowPage } from "../features/detail-drawer-over-row/DetailDrawerOverRowPage";

export const detailDrawerOverRowRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/detail-drawer-over-row",
	component: DetailDrawerOverRowPage,
});

export default detailDrawerOverRowRoute;
